import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface MarginRatiosInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.EBITDAM'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.OPM'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.NPM'?: ResultRow;
}
export class MarginRatios {
  'RESULTS.DATA.ECONOMIC_METRICS.EBITDAM';
  'RESULTS.DATA.ECONOMIC_METRICS.OPM';
  'RESULTS.DATA.ECONOMIC_METRICS.NPM';
  /** EBITDA margin */
  get ebitdam() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.EBITDAM'];
  }
  set ebitdam(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.EBITDAM'] = value;
  }
  /** operating profit margin */
  get opm() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.OPM'];
  }
  set opm(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.OPM'] = value;
  }
  /** net profit margin */
  get npm() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.NPM'];
  }
  set npm(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.NPM'] = value;
  }
  constructor(param: MarginRatiosInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.EBITDAM'] = param['RESULTS.DATA.ECONOMIC_METRICS.EBITDAM']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.EBITDAM'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.OPM'] = param['RESULTS.DATA.ECONOMIC_METRICS.OPM']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.OPM'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.NPM'] = param['RESULTS.DATA.ECONOMIC_METRICS.NPM']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.NPM'])
      : new ResultRow();
  }

  deepCopy() {
    return new MarginRatios(cloneDeep(this));
  }
}